import { Camera, FileText, Send, Clock } from "lucide-react";
import { Card } from "@/components/ui/card";

const features = [
  {
    icon: Camera,
    title: "Snap a Photo",
    description: "Take a picture of your work site, materials, or completed job with your phone camera.",
    gradient: "from-primary to-blue-600",
  },
  {
    icon: FileText,
    title: "AI Creates Quote",
    description: "Our AI instantly analyzes the photo and generates an itemized quote with pricing.",
    gradient: "from-accent to-orange-600",
  },
  {
    icon: Send,
    title: "Send Instantly",
    description: "Share your professional invoice via WhatsApp, Telegram, or email in one tap.",
    gradient: "from-success to-green-600",
  },
  {
    icon: Clock,
    title: "Get Paid Faster",
    description: "Professional quotes mean faster approvals and quicker payments from your clients.",
    gradient: "from-purple-500 to-purple-700",
  },
];

const Features = () => {
  return (
    <section className="py-24 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-20 animate-fade-in-up">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-foreground mb-6">
            From Photo to Payment in 60 Seconds
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
            Built for busy contractors who need to send quotes on-site, while the customer is still there.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <Card 
              key={index}
              className="p-8 md:p-10 hover:shadow-xl transition-all duration-500 border-2 hover:border-primary/30 group animate-fade-in hover:-translate-y-2"
              style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'both' }}
            >
              <div className="flex flex-col h-full">
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 shadow-md group-hover:shadow-lg`}>
                  <feature.icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-xl md:text-2xl font-display font-bold text-foreground mb-4 group-hover:text-primary transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed text-base">
                  {feature.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
